<script>
    import { createEventDispatcher } from "svelte";
    import { _ } from "../services/i18n";
    import { isValidUser } from "../services/vendors";
    import Icon from "../ui/Icon.svelte";
    import { mdiEye, mdiEyeOff } from "@mdi/js";
    import Switch from "../ui/Switch.svelte";
    import { alert } from "../services/stores/alert";
    import { userStore } from "../services/session.js";

    const dispatch = createEventDispatcher();
    export let editVendor, modeEdit;
    let visible = false;

    const saveVendor = async (e) => {
        await loginValid(0);
        if (!valid) {
            e.preventDefault();
            alert.newAlert({
                type: "error",
                message: invalidMsg,
                timeOut: 5000,
            });
        } 
        else {
            dispatch("save", editVendor);
            location.reload();
        } 
    };

    const back = () => dispatch("back");

    const togglePass = () => {
        visible = !visible;
        document.querySelector("#password").type = visible
            ? "text"
            : "password";
    };

    let valid = true,
        invalidMsg,
        timeoutId;
    const loginValid = async (time = 3000) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(async () => {
            const validUser = await isValidUser(editVendor.email);
            valid = validUser.status;
            invalidMsg = validUser.message;
        }, time);
    };
</script>

<div class="container">
    <form on:submit|preventDefault={saveVendor} autocomplete="off">
        <ul class="flex-outer">
            <li style="justify-content: center;">
                <h2>{$_(`vendors_editUser_page_${modeEdit}`)}</h2>
            </li>
            <li>
                <label for="email">{$_("vendors_editUser_page_login")}:</label>
                <input
                    autocomplete="login"
                    id="login"
                    type="text"
                    bind:value={editVendor.login}
                    maxlength="320"
                    disabled={modeEdit === "edit"}
                    class:invalid={!valid}
                    required
                />
            </li>
            <li>
                <label for="name">{$_("vendors_editUser_page_name")}:</label>
                <input
                    id="name"
                    name="name"
                    type="text"
                    bind:value={editVendor.name}
                    required
                />
            </li>
            <li>
                <label for="password"
                    >{$_("vendors_editUser_page_password")}:</label
                >
                <div id="password-box">
                    <input
                        autocomplete="new-password"
                        id="password"
                        type="password"
                        bind:value={editVendor.password}
                        minlength="4"
                        maxlength="60"
                        required
                    /><Icon
                        style="padding: 25px; cursor: pointer; position: absolute; right: 0"
                        color="#27589c"
                        path={visible ? mdiEyeOff : mdiEye}
                        on:click={togglePass}
                    ></Icon>
                </div>
            </li>
            <li>
                <label for="email">{$_("vendors_editUser_page_email")}:</label>
                <input
                    autocomplete="email"
                    id="email"
                    type="email"
                    bind:value={editVendor.email}
                    maxlength="320"
                    required
                />
            </li>
            <li>
                <label for="phone">{$_("vendors_editUser_page_phone")}:</label>
                <input
                    autocomplete="tel"
                    id="phone"
                    type="tel"
                    bind:value={editVendor.phone}
                    maxlength="15"
                />
            </li>
            {#if $userStore.getAcl("orderConfirmation")}
                <li
                    class="check-box"
                    style="font-weight: 300; letter-spacing: .09em; text-transform: uppercase; padding: 8px"
                >
                    <Switch
                        label={$_("vendors_editUser_page_confirmOrders")}
                        lined="start"
                        bind:checked={editVendor.acl.orderConfirmation}
                    />
                </li>
            {/if}
            <li class="buttons-box">
                <button
                    class="btn-3d second"
                    type="button"
                    id="back-button"
                    on:click={back}>{$_("vendors_editUser_page_back")}</button
                >
                <button class="btn-3d second" type="submit" id="create-button"
                    >{$_("vendors_editUser_page_save")}</button
                >
            </li>
        </ul>
    </form>
</div>

<style>
    h2 {
        margin: 25px auto 10px auto;
        max-width: max-content;
        font-size: 22px;
        color: var(--theme-color-4);
        letter-spacing: 1.5px;
        font-weight: 400;
        text-transform: uppercase;
    }

    #password-box {
        width: 100%;
        max-height: 50px;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        border-radius: 5px;
        position: relative;
    }

    #password {
        margin: 0;
    }

    .container {
        width: 80%;
        max-width: 1200px;
        margin: 0 auto;
    }

    .container * {
        box-sizing: border-box;
    }

    .flex-outer {
        list-style-type: none;
        padding: 0;
        max-width: 800px;
        margin: 0 auto;
    }

    .flex-outer li {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        margin-bottom: 0px;
    }

    .flex-outer > li:not(:last-child) {
        margin-bottom: 20px;
    }

    .flex-outer li label {
        padding: 8px;
        font-weight: 300;
        letter-spacing: 0.09em;
        text-transform: uppercase;
        flex: 1 0 120px;
    }

    .flex-outer > li > label {
        flex: 1 0 120px;
        max-width: 220px;
        max-height: 50px;
    }

    .flex-outer > li > label + * {
        flex: 1 0 220px;
    }

    .flex-outer li input:not([type="checkbox"]) {
        padding: 15px;
    }

    input {
        border-style: ridge;
    }

    #back-button {
        align-self: flex-end;
        margin-left: 0;
        background-color: #f2f2f2;
        color: #333;
    }

    .invalid {
        border-color: red;
    }

    input {
        font-family: inherit;
        font-size: inherit;
        -webkit-padding: 0.4em 0;
        padding: 10px;
        margin: 0 0 0.5em 0;
        box-sizing: border-box;
        border: 1px solid var(--gray-color);
        border-radius: 5px;
        width: 100%;
        text-align: center;
        color: var(--theme-color-1);
        max-height: 50px;
        font-size: 16px;
        background-color: white;
        letter-spacing: 1.5px;
        font-weight: 300;
    }

    label {
        max-height: 40px !important;
        color: var(--theme-color-4);
        font-weight: 400 !important;
        font-size: 18px;
    }

    .flex-outer > .buttons-box {
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
    }

    #back-button {
        background-color: var(--theme-color-1);
        color: var(--bs-white);
        padding: 7px;
        width: 150px;
    }

    #create-button {
        padding: 7px;
        width: 150px;
    }

    .check-box {
        width: 100%;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
    }

    @media screen and (max-width: 768px) and (min-width: 0px) {
        h2 {
            font-size: 18px;
            margin: 0px;
        }

        label {
            font-size: 14px;
        }

        input {
            max-height: 30px;
        }

        #password-box {
            max-height: 32px;
        }

        .flex-outer > li:not(:last-child) {
            margin-bottom: 10px;
        }

        .check-box {
            font-size: 10px;
        }

        #create-button {
            font-size: 12px;
            width: 140px;
        }

        #back-button {
            font-size: 12px;
            width: 140px;
            margin-right: 10px;
        }
    }
</style>
